document.addEventListener('DOMContentLoaded', function() {

/* ── ANNOUNCEMENT BAR ──
   sections/announcement-bar.liquid already sets --hv2-ann-h to a static
   value (matching assets/theme.css's .hv2-announcement min-height) and
   hides the bar synchronously before first paint if it was dismissed
   earlier this session, so the header never visibly renders under the bar
   on load. This script is the progressive-enhancement layer on top of
   that: it re-measures the bar's real height once fonts/layout settle, in
   case a message wraps to a second line on a narrow screen (something the
   static value can't predict), and it owns ongoing behavior — resize,
   rotation, and the dismiss click — for the rest of the page's life. The
   dismissed check below only re-confirms what the inline script already
   applied; it's a safety net for browsers/CSPs that skip inline scripts,
   not the thing preventing the flash. */
(function() {
  var bar = document.querySelector('[data-hv2-announcement]');
  if (!bar) return;
  var KEY = 'hv2_announcement_dismissed';
  var dismissed = false;
  try { dismissed = !!sessionStorage.getItem(KEY); } catch (e) {}
  if (dismissed) bar.hidden = true;

  function syncOffset() {
    var h = bar.hidden ? 0 : bar.offsetHeight;
    document.documentElement.style.setProperty('--hv2-ann-h', h + 'px');
  }
  syncOffset();
  window.addEventListener('load', syncOffset);
  window.addEventListener('resize', syncOffset);
  if (window.document.fonts && document.fonts.ready) {
    document.fonts.ready.then(syncOffset);
  }

  var closeBtn = bar.querySelector('[data-hv2-announcement-close]');
  if (closeBtn) {
    closeBtn.addEventListener('click', function() {
      bar.hidden = true;
      try { sessionStorage.setItem(KEY, '1'); } catch (e) {}
      syncOffset();
    });
  }

  var msgs = Array.prototype.slice.call(bar.querySelectorAll('[data-hv2-announcement-msg]'));
  if (msgs.length > 1) {
    var track = bar.querySelector('[data-hv2-announcement-track]');
    var seconds = (track && parseFloat(getComputedStyle(track).getPropertyValue('--hv2-ann-rotate'))) || 4;
    var idx = 0;
    setInterval(function() {
      var outgoing = msgs[idx];
      idx = (idx + 1) % msgs.length;
      var incoming = msgs[idx];

      outgoing.classList.remove('is-active');
      outgoing.classList.add('is-leaving');
      incoming.classList.add('is-active');

      // Once outgoing has finished sliding off-screen left, snap it back to
      // its off-screen-right resting position with the transition briefly
      // disabled, so it doesn't visibly slide back across the bar — only
      // then is it ready to slide in again on a future cycle.
      setTimeout(function() {
        outgoing.style.transition = 'none';
        outgoing.classList.remove('is-leaving');
        void outgoing.offsetWidth;
        outgoing.style.transition = '';
      }, 520);
    }, seconds * 1000);
  }
})();

/* ── CART COUNT ──
   Syncs .nav-cart-count badges (sections/header.liquid) from /cart.js on
   every normal page load — the per-action updates after an add-to-cart
   (assets/pdp.js, assets/homepage.js, the cart drawer's own JS) each do
   their own fetch-and-sync right after that action; this is the one that
   covers everything else (back button, direct navigation, etc). */
function updateCartCount() {
  fetch('/cart.js')
  .then(function(r) { return r.json(); })
  .then(function(cart) {
    var counters = document.querySelectorAll('.nav-cart-count');
    counters.forEach(function(el) {
      el.textContent = cart.item_count;
      el.style.display = cart.item_count > 0 ? 'flex' : 'none';
    });
  });
}

/* ── PREDICTIVE SEARCH (navbar + mobile) ── */
(function() {
  var CONCERN_MAP = [
    { tag: 'glow-brightening', label: 'Glow & Brightening', keywords: ['glow','brightening','bright skin','dark spot','dark spots','pigmentation','dull skin','even tone','radiance','uneven skin tone'] },
    { tag: 'oil-control', label: 'Oil Control', keywords: ['oily skin','oil control','excess oil','shine control','oiliness'] },
    { tag: 'acne-pores', label: 'Acne & Pores', keywords: ['acne','pimple','pimples','breakout','breakouts','pores','blackhead','blackheads','acne prone','acne-prone'] },
    { tag: 'hydration', label: 'Hydration', keywords: ['dry skin','hydration','moisture','dryness','dehydrated','dehydration'] },
    { tag: 'anti-aging', label: 'Anti-Aging', keywords: ['anti aging','anti-aging','anti ageing','anti-ageing','wrinkle','wrinkles','fine line','fine lines','aging skin','ageing skin'] },
    { tag: 'hair-fall', label: 'Hair Fall', keywords: ['hair fall','hairfall','hair loss','thinning hair','hair thinning'] },
    { tag: 'dandruff', label: 'Dandruff', keywords: ['dandruff','flaky scalp','dry scalp','scalp flakes'] },
    { tag: 'frizz-shine', label: 'Frizz & Shine', keywords: ['frizz','frizzy hair','frizzy','dull hair','hair shine'] },
    { tag: 'hair-growth', label: 'Hair Growth', keywords: ['hair growth','hair regrowth','thicker hair','hair thickness'] }
  ];
  function matchConcern(q) {
    var lower = q.toLowerCase();
    for (var i = 0; i < CONCERN_MAP.length; i++) {
      var c = CONCERN_MAP[i];
      for (var j = 0; j < c.keywords.length; j++) {
        if (lower.indexOf(c.keywords[j]) > -1) return c;
      }
    }
    return null;
  }
  window.ujjwalaMatchConcern = matchConcern;

  function rupees(val) {
    var n = parseFloat(val);
    if (isNaN(n)) return '';
    try { return '₹' + n.toLocaleString('en-IN', { maximumFractionDigits: 0 }); }
    catch (e) { return '₹' + Math.round(n); }
  }
  function esc(s) { return String(s).replace(/[&<>"]/g, function(c) {
    return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
  }); }
  function resultsUrl(q) {
    return '/search?q=' + encodeURIComponent(q) + '&type=product&options[prefix]=last';
  }

  function attach(input) {
    if (!input) return;
    var wrap = input.closest('.nav-search-wrap');
    var dd = wrap ? wrap.querySelector('.search-dropdown') : null;
    if (!dd) return;
    var timer = null;

    function hide() { dd.hidden = true; dd.innerHTML = ''; }
    function go(q) {
      if (!q) return;
      var concern = matchConcern(q);
      if (concern) { window.location.href = '/collections/all/' + concern.tag; return; }
      window.location.href = resultsUrl(q);
    }

    input.addEventListener('keydown', function(e) {
      if (e.key === 'Enter') { go(input.value.trim()); }
      else if (e.key === 'Escape') { hide(); }
    });

    input.addEventListener('input', function() {
      var q = input.value.trim();
      clearTimeout(timer);
      if (q.length < 2) { hide(); return; }
      timer = setTimeout(function() {
        var concern = matchConcern(q);
        var concernBanner = concern
          ? '<a class="sr-all" href="/collections/all/' + concern.tag + '" style="font-weight:700">Shop ' + esc(concern.label) + ' products &rarr;</a>'
          : '';
        var url = '/search/suggest.json?q=' + encodeURIComponent(q) +
          '&resources[type]=product&resources[limit]=6' +
          '&resources[options][unavailable_products]=last';
        fetch(url)
          .then(function(r) { return r.json(); })
          .then(function(data) {
            if (input.value.trim() !== q) return; // stale response
            var list = (data.resources && data.resources.results && data.resources.results.products) || [];
            if (!list.length) {
              dd.innerHTML = concernBanner || ('<div class="sr-empty">No products found for “' + esc(q) + '”</div>');
              dd.hidden = false;
              return;
            }
            var html = concernBanner + list.map(function(p) {
              var img = (p.featured_image && p.featured_image.url) || p.image || '';
              var price = rupees(p.price);
              return '<a class="sr-item" href="' + p.url + '">' +
                (img ? '<img class="sr-thumb" src="' + img + '" alt="" loading="lazy">' : '<span class="sr-thumb"></span>') +
                '<span class="sr-info"><span class="sr-name">' + esc(p.title) + '</span>' +
                (price ? '<span class="sr-price">' + price + '</span>' : '') +
                '</span></a>';
            }).join('');
            html += '<a class="sr-all" href="' + resultsUrl(q) + '">View all results</a>';
            dd.innerHTML = html;
            dd.hidden = false;
          })
          .catch(function() { hide(); });
      }, 200);
    });

    input.addEventListener('focus', function() {
      if (dd.innerHTML && input.value.trim().length >= 2) dd.hidden = false;
    });
    document.addEventListener('click', function(e) {
      if (wrap && !wrap.contains(e.target)) hide();
    });
  }

  document.querySelectorAll('.nav-search').forEach(attach);
  attach(document.getElementById('mobile-search-input'));
})();

/* ── HAMBURGER MENU ── */
(function() {
  var hamburger = document.getElementById('nav-hamburger');
  var dropdown  = document.getElementById('mobile-nav-dropdown');
  if (!hamburger || !dropdown) return;
  function openMenu() {
    dropdown.classList.add('open');
    hamburger.innerHTML = '&#10005;';
    document.addEventListener('click', outsideClick);
  }
  function closeMenu() {
    dropdown.classList.remove('open');
    hamburger.innerHTML = '&#9776;';
    document.removeEventListener('click', outsideClick);
  }
  function outsideClick(e) {
    if (!e.target.closest('.site-header')) closeMenu();
  }
  hamburger.addEventListener('click', function(e) {
    e.stopPropagation();
    dropdown.classList.contains('open') ? closeMenu() : openMenu();
  });
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') closeMenu();
  });
})();

/* ── MOBILE SEARCH TOGGLE ── */
(function() {
  var toggle = document.getElementById('nav-search-toggle');
  var panel  = document.getElementById('mobile-search-panel');
  var input  = document.getElementById('mobile-search-input');
  if (!toggle || !panel) return;
  toggle.addEventListener('click', function(e) {
    e.stopPropagation();
    var open = !panel.hidden;
    panel.hidden = open;
    toggle.setAttribute('aria-expanded', String(!open));
    if (!open && input) { input.focus(); }
  });
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && !panel.hidden) { panel.hidden = true; toggle.setAttribute('aria-expanded', 'false'); }
  });
})();

updateCartCount();

}); // end DOMContentLoaded
